import { enhancedApi as generatedCoursesApi } from './courses'
import { courseCatalogCacheTags } from './courseCatalogCacheTags'

// The generator emits no cache tags, so they are applied here rather than patched into
// `courses.ts`, which the next `pnpm api-generate` would wipe. Import hooks from this module,
// never from `./courses`, or a chunk that skips this file ships without the tags.

// Each policy key maps onto itself only when it names a generated endpoint, so a regeneration
// rename fails compilation here instead of enhanceEndpoints silently ignoring the policy.
const checkedCacheTags: {
  [K in keyof typeof courseCatalogCacheTags]: K extends keyof (typeof generatedCoursesApi)['endpoints']
    ? (typeof courseCatalogCacheTags)[K]
    : never
} = courseCatalogCacheTags

export const courseCatalogApi = generatedCoursesApi.enhanceEndpoints({ endpoints: checkedCacheTags })

export const {
  useListCoursesQuery,
  useGetCourseByCodeQuery,
  useCreateCourseMutation,
  useUpdateCourseByCodeMutation,
  useDeleteCourseByCodeMutation,
  useListCourseVariantsQuery,
  useCreateCourseVariantMutation,
  useDeleteCourseVariantMutation,
  useUpdateCourseVariantMutation,
  useSyncLmdhCourseVariantsMutation,
  useGetCourseVariantByIdQuery,
} = courseCatalogApi
export const { usePrefetch: useCourseCatalogPrefetch } = courseCatalogApi
export * from './courses'
